(function ($) {
  'use strict';

  var all_links = document.querySelectorAll('a');
  for (var i = 0; i < all_links.length; i++) {
    var a = all_links[i];
    if (a.hostname !== location.hostname) {
      if (
        a.hostname.indexOf('amazonaws') < 0 &&
        a.hostname.indexOf('cloudfront') < 0
      ) {
        a.rel = 'noopener';
        a.target = '_blank';
      }
    }
  }
})(jQuery);
